import { render, staticRenderFns } from "./MiniBasket.vue?vue&type=template&id=2c79ebde&scoped=true&"
import script from "./MiniBasket.vue?vue&type=script&lang=js&"
export * from "./MiniBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79ebde",
  null
  
)

export default component.exports